import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { addToChainAfter, ApiHandlerDiscreteParameter, HasOnError } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import loadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import {
    chain,
    DispatchResetPaymentProfiles,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    isPending?: boolean;
    isAdyenDropIn?: boolean;
    adyenPspReference?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
    payerId: string;
    maskedCardNumber: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;

export const PopulateApiParameterCustom: HandlerType = props => {
    if (!props.cartToUpdate) {
        return;
    }

    const checkoutAccessorial = localStorage.getItem("checkoutAccessorial");
    const state = props.getState() as CustomApplicationState;
    const isShippingServicesDisabled = state?.context?.session?.properties?.disableSpecialShippingServices === "true";
    const deliveryInfo = state.KGPState.ShippingDeliveryInfoStore?.DeliveryInfo;
    const applyheaderDateToAllLine = state.KGPState.ApplyDateToAllLineStore.applyDateToAllLines;
    props.apiParameter = {
        cart: {
            ...props.apiParameter.cart,
            properties: {
                ...props.cartToUpdate.properties,
                ...(checkoutAccessorial &&
                    !isShippingServicesDisabled && {
                        selectedAccessorials: `${checkoutAccessorial}`,
                        selectedAccessorialsDisplay: localStorage.getItem("checkoutAccessorialCompleted") || "",
                    }),
                ...(deliveryInfo?.firstName && {
                    deliveryContactFirstName: deliveryInfo?.firstName,
                }),
                ...(deliveryInfo?.lastName && {
                    deliveryContactLastName: deliveryInfo?.lastName,
                }),
                ...(deliveryInfo?.phone && {
                    deliveryContactPhone: deliveryInfo?.phone,
                }),
                ...(deliveryInfo?.email && {
                    deliveryContactEmail: deliveryInfo?.email,
                }),
                isHeaderDate: applyheaderDateToAllLine ? "true" : "false",
                ...(state.KGPState.CheckoutReview.expeditedUserName && {
                    cartContactName: state.KGPState.CheckoutReview.expeditedUserName,
                }),
                ...(state.KGPState.CheckoutReview.expeditedUserphone && {
                    cartContactPhone: state.KGPState.CheckoutReview.expeditedUserphone,
                }),
            },
        },
    };
    localStorage.removeItem("checkoutAccessorial");
    localStorage.removeItem("checkoutAccessorialCompleted");
    localStorage.removeItem("orderNotes");
    localStorage.removeItem("approverNotes");
    localStorage.removeItem("checkoutDeliveryInfo");
};

// 3239: reloaded session to get updated customer po number
export const reLoadSession: HandlerType = props => {
    props.dispatch({ type: "Custom/CheckoutReview/ResetCheckoutReviewStoreFields" });
    props.dispatch(loadSession({ isSessionUpdate: true }));
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterCustom);
addToChainAfter(chain, DispatchResetPaymentProfiles, reLoadSession);
